<div *ngIf="isLoading" class="skeleton-wrapper">
    <!-- Skeleton Header -->
    <div class="skeleton-header">
        <div class="skeleton-box skeleton-breadcrumb"></div>
        <div class="skeleton-box skeleton-back"></div>
    </div>

    <!-- Skeleton Main Content -->
    <div class="skeleton-main">
        <div class="skeleton-content-grid">
            <!-- Left Sidebar -->
            <div class="skeleton-card">
                <div class="skeleton-circle" style="width: 120px; height: 120px;"></div>
                <div class="skeleton-box" style="height: 28px; width: 80%;"></div>
                <div class="skeleton-box" style="height: 20px; width: 60%;"></div>
                <div class="skeleton-box" style="height: 150px; width: 100%;"></div>
                <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
            </div>

            <!-- Right Area -->
            <div style="display: flex; flex-direction: column; gap: 16px;">
                <!-- Status & Action Buttons -->
                <div class="skeleton-card" style="flex-direction: row; justify-content: space-between; align-items: center; padding: 20px;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <div class="skeleton-box" style="height: 24px; width: 100px;"></div>
                        <div class="skeleton-box" style="height: 24px; width: 120px; border-radius: 12px;"></div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div class="skeleton-box" style="height: 36px; width: 80px;"></div>
                        <div class="skeleton-box" style="height: 36px; width: 80px;"></div>
                        <div class="skeleton-box" style="height: 36px; width: 120px;"></div>
                    </div>
                </div>

                <!-- Stats Filters -->
                <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <div class="skeleton-box" style="height: 38px; width: 120px;"></div>
                    <div class="skeleton-box" style="height: 38px; width: 100px;"></div>
                    <div class="skeleton-box" style="height: 38px; width: 110px;"></div>
                    <div class="skeleton-box" style="height: 38px; width: 110px;"></div>
                    <div class="skeleton-box" style="height: 38px; width: 100px;"></div>
                </div>

                <!-- Info Grid -->
                <div class="skeleton-card" style="align-items: stretch; padding: 24px;">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div class="skeleton-box" style="height: 16px; width: 80px;"></div>
                            <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div class="skeleton-box" style="height: 16px; width: 80px;"></div>
                            <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div class="skeleton-box" style="height: 16px; width: 100px;"></div>
                            <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div class="skeleton-box" style="height: 16px; width: 100px;"></div>
                            <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 8px; grid-column: span 2;">
                            <div class="skeleton-box" style="height: 16px; width: 80px;"></div>
                            <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
                        </div>
                    </div>
                </div>

                <!-- Documents Section -->
                <div class="skeleton-card" style="align-items: stretch;">
                    <div class="skeleton-box" style="height: 24px; width: 180px; margin-bottom: 12px;"></div>
                    <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 12px;">
                        <div class="skeleton-box" style="height: 180px; border-radius: 10px;"></div>
                        <div class="skeleton-box" style="height: 180px; border-radius: 10px;"></div>
                        <div class="skeleton-box" style="height: 180px; border-radius: 10px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isLoading && driver" class="driver-details-container">


    <!-- PAGE HEADER (Uniform with other screens) -->
    <div class="page-header">
        <!-- Go Back Link (Top Right) -->
        <a href="javascript:void(0)" class="go-back-link" (click)="goToDrivers()">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            Go Back
        </a>
    </div>

    <!-- MAIN CONTENT -->
    <div *ngIf="driver" class="main-content">
        <div class="content-wrapper">

            <!-- LEFT SIDEBAR - DRIVER CARD -->
            <div class="driver-card">
                <div class="driver-avatar-wrapper">
                    <img *ngIf="driver?.profile_image" [src]="driver.profile_image" class="driver-image"
                        alt="Driver Image" />
                    <!-- Show initials as fallback -->
                    <div *ngIf="!driver?.profile_image" class="driver-avatar avatar-grey">
                        {{ getDriverInitials(driver) }}
                    </div>
                    <div class="completion-badge">{{likePercentage === '0.00%' ? '100%' : likePercentage }}</div>
                </div>

                <div style="text-align: center; width: 100%;">
                    <h2 class="driver-name">{{ driver.first_name }} {{ driver.last_name }} <span
                            *ngIf="driver.groups?.[0]?.id === 3"> (HD)</span></h2>
                    <!-- <p class="driver-type">{{ driver.type }}</p> -->
                    <p class="joined-date">Joined: <strong>{{ driver.date_joined | date }}</strong></p>
                </div>

                <div class="driver-map">
                    <!-- Live Location Badge -->
                    <div class="map-overlay">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <circle cx="12" cy="12" r="8" />
                        </svg>
                        Live Location
                    </div>

                    <!-- Google Maps Embed -->
                    <div class="order-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d109741.02912911311!2d76.69635423567143!3d30.900473837279785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fb3e5c58a9c65%3A0x32ab0ae38bce6ac5!2sLudhiana%2C%20Punjab!5e0!3m2!1sen!2sin!4v1673456789012!5m2!1sen!2sin"
            loading="lazy">
          </iframe>
          <div class="map-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                clip-rule="evenodd" />
            </svg>
            Delivery Location
          </div>
        </div>
                </div>

                <button *ngIf="driver.drivertime" class="track-button" (click)="trackDriver()"  [ngStyle]="{
                                    'pointer-events': (driver.drivertime[0]?.latitude && driver.drivertime[0]?.longitude) ? 'auto' : 'none',
                                    'opacity': (driver.drivertime[0]?.latitude && driver.drivertime[0]?.longitude) ? '1' : '0.5'
                                  }">
                    <span class="track-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                        </svg>
                    </span>
                    Track Driver
                </button>
            </div>

            <!-- RIGHT CONTENT AREA -->
            <div class="details-content">

                <!-- STATUS SECTION -->
                <div class="status-section">
                    <div class="status-header">
                        <div class="status-left">
                            <span class="status-label">Driver Status:</span>
                            <div class="status-toggle" (click)="toggleStatus()">
                                <div class="toggle-switch" [class.inactive]="!driver.is_active">
                                    <div class="toggle-knob"></div>
                                </div>
                                <span class="status-text" [class.inactive]="!driver.is_active">
                                    {{ getStatusText(driver.is_active) }}
                                </span>
                            </div>
                        </div>
                        <!-- (click)="editDriver()" -->
                        <div class="action-buttons" >
                            <button (click)="editDriver()" class="action-btn btn-edit">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                </svg>
                                Edit
                            </button>
                            <button class="action-btn btn-delete" (click)="deleteDriver()">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                </svg>
                                Delete
                            </button>
                            <button class="action-btn btn-notifications" (click)="openNotifications()">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                                </svg>
                                Recent Notifications
                            </button>
                        </div>
                    </div>

                    <!-- STATS FILTERS -->
                    <div class="stats-filters">
                        <button class="filter-chip all"
                         [disabled]="todayOrderCount === 0"
                            (click)="filterStats('today')">
                            Today's Order
                            <span class="count">{{ todayOrderCount }}</span>
                        </button>
                        <button class="filter-chip pending"
                         [disabled]="pendingOrderCount === 0"
                            (click)="filterStats('pending')">
                            Pending
                            <span class="count">{{ pendingOrderCount }}</span>
                        </button>
                        <button class="filter-chip successful"
                         [disabled]="successfullOrderCount === 0"
                            (click)="filterStats('successful')">
                            Successful
                            <span class="count">{{ successfullOrderCount }}</span>
                        </button>
                        <button class="filter-chip unsuccessful"
                         [disabled]="unSuccessfullOrderCount === 0"
                            (click)="filterStats('unsuccessful')">
                            Unsuccessful
                            <span class="count">{{ unSuccessfullOrderCount }}</span>
                        </button>
                        <button class="filter-chip cancelled"
                         [disabled]="cancelled === 0"
                            (click)="filterStats('cancelled')">
                            Cancelled
                            <span class="count">{{ cancelled }}</span>
                        </button>
                    </div>
                </div>

                <!-- DRIVER INFORMATION -->
                <div class="info-section">
                    <div class="info-grid">
                        <!-- First Name -->
                        <div class="info-group">
                            <label class="info-label">First Name</label>
                            <div class="info-value-wrapper">
                                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                </svg>
                                <span class="info-value">{{ driver.first_name }}</span>
                            </div>
                        </div>

                        <!-- Last Name -->
                        <div class="info-group">
                            <label class="info-label">Last Name</label>
                            <div class="info-value-wrapper">
                                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                </svg>
                                <span class="info-value">{{ driver.last_name }}</span>
                            </div>
                        </div>

                        <!-- Phone -->
                        <div class="info-group">
                            <label class="info-label">Phone Number</label>
                            <div class="info-value-wrapper">
                                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                </svg>
                                <span class="info-value">{{ driver.phone_number }}</span>
                                <button class="copy-button" (click)="copyToClipboard(driver.phone_number)" title="Copy">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="info-group">
                            <label class="info-label">Email Address</label>
                            <div class="info-value-wrapper">
                                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                </svg>
                                <span class="info-value">{{ driver.email }}</span>
                                <button class="copy-button" (click)="copyToClipboard(driver.email)" title="Copy">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Address -->
                        <div class="info-group full-width">
                            <label class="info-label">Address</label>
                            <div class="info-value-wrapper">
                                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>
                                <span class="info-value">{{ driver.address }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- NOTIFICATION SETTINGS -->
                    <div class="notification-section">
                        <div class="notification-left">
                            <h3 class="notification-header">Send Notification</h3>
                            <p class="notification-description">
                                Send notifications to this driver about orders, updates, or information.
                            </p>
                        </div>
                        <button class="notification-button" (click)="openModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.75 9h16.5" />
                            </svg>
                            Send Notification
                        </button>
                    </div>
                </div>

                <!-- UPLOADED DOCUMENTS -->
                <div class="documents-section">
                    <div class="section-header">
                        <h3 class="section-title">Uploaded Documents:</h3>
                    </div>
                    <div class="documents-grid">
                        <div class="document-card" *ngFor="let doc of documents; trackBy: trackByDocId"
                            (click)="viewDocument(doc)">

                            <div class="document-icon">

                                <!-- Agar document image hai to direct backend wali image dikhao -->
                                <img *ngIf="doc.type === 'image'" [src]="doc.url" alt="{{ doc.name }}"
                                    class="doc-preview-image" />

                                <!-- PDF ke liye icon -->
                                <svg *ngIf="doc.type === 'pdf'" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                </svg>

                                <!-- Other files ke liye default icon -->
                                <svg *ngIf="doc.type === 'doc'" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0z" />
                                </svg>

                            </div>

                            <div class="document-name">{{ doc.name }}</div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- SEND NOTIFICATION MODAL -->
    <div *ngIf="isModalOpen" class="modal show" (click)="onBackdropClick($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">
                    <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                    </svg>
                    Send Notification
                </h2>
                <button class="modal-close" (click)="closeModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div class="modal-body">
                <div class="form-group">
                    <label class="form-label">
                        <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                        </svg>
                        Send To
                        <span class="required">*</span>
                    </label>
                    <div class="recipient-type-toggle">
                        <!-- <button class="toggle-option" 
                    [class.active]="recipientType === 'customers'"
                    (click)="toggleRecipientType('customers')">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="toggle-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
              Customers
            </button> -->
                        <button class="toggle-option" [class.active]="recipientType === 'drivers'"
                            (click)="toggleRecipientType('drivers')">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                stroke="currentColor" class="toggle-icon">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                            </svg>
                            Drivers
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">
                        <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>
                        Message
                        <span class="required">*</span>
                    </label>
                    <textarea class="modal-textarea" placeholder="Enter your message here..." [maxlength]="maxChars"
                        [(ngModel)]="messageText" (input)="updateCharCount()">
                     </textarea>
                    <div class="error-text" *ngIf="showError">
                        Message is required
                    </div>
                    <div class="char-count" [ngClass]="getCharCountClass()">
                        <span>{{ charCount }}</span> / {{ maxChars }}
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">
                        <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                        </svg>
                        Attachments
                        <span class="optional">(Optional)</span>
                    </label>
                    <input type="file" #fileInput class="file-input" multiple accept="image/*"
                        (change)="onFileSelect($event)">
                    <label for="fileInput" class="file-upload-btn" (click)="fileInput.click()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        Add Files
                    </label>
                    <div class="file-preview-list">
                        <div *ngFor="let preview of filePreviews; let i = index" class="file-preview-item">
                            <img [src]="preview.url" [alt]="preview.file.name">
                            <button class="file-preview-remove" (click)="removeFile(i)" type="button">×</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn-secondary" (click)="closeModal()">Cancel</button>
                <button class="btn-primary" (click)="sendNotification()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                    </svg>
                    Send Notification
                </button>
            </div>
        </div>
    </div>
    <!-- Notification Panel Modal -->
    <div class="modal-overlay" [class.active]="isNotificationPanelOpen" (click)="closeNotifications()">
        <div class="notification-panel" [class.active]="isNotificationPanelOpen" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="panel-header">
                <div class="header-top">
                    <h2 class="panel-title">Recent Notifications</h2>
                    <button class="close-btn" (click)="closeNotifications()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="tabs-container">
                    <button class="tab" [class.active]="activeTab === 'RN'" (click)="switchTab('RN')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                clip-rule="evenodd" />
                        </svg>
                        Recent Notifications
                        <span class="tab-badge" *ngIf="driverUnreadCount > 0">{{ driverUnreadCount }}</span>
                    </button>
                    <button class="tab" [class.active]="activeTab === 'RTH'" (click)="switchTab('RTH')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                clip-rule="evenodd" />
                        </svg>
                        Recent Trip History
                        <span class="tab-badge" *ngIf="driverUnreadCount > 0">{{ driverUnreadCount }}</span>
                    </button>
                </div>
            </div>

            <!-- Content -->
            <div class="panel-content">
                <!-- View All Button -->
                <div class="view-all-section">
                    <button class="view-all-btn-top" (click)="viewAllNotifications()" [disabled]="
    (activeTab === 'RN' && (!filteredNotifications || filteredNotifications.length === 0)) ||
    (activeTab === 'RTH' && (!tripHistory || tripHistory.length === 0))
  ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                        View All {{ activeTab === 'RTH' ? 'Recent Trip History' : 'Recent Notifications' }}
                    </button>
                </div>

                <div *ngIf="filteredNotifications" class="notification-list">
                    <div class="notification-item" *ngFor="let notification of filteredNotifications"
                        [class.unread]="notification.isUnread" [class.has-image]="notification.image"
                        (click)="markAsRead(notification)">
                        <div class="notification-item-top"
                            *ngIf="notification?.image && notification.image !== ''; else normalLayout">

                            <div class="notification-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                                    <path fill-rule="evenodd"
                                        d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="notification-content">
                                <div class="notification-message">{{ notification.message }}</div>
                                <div class="notification-time">{{ notification.sent_at | dateAgo }}</div>
                            </div>
                          <img 
  [src]="notification.image" 
  alt="Notification image" 
  class="notification-image"
  (click)="openImage(notification.image)"
  style="cursor: pointer;"
>
                        </div>

                        <ng-template #normalLayout>
                            <div class="notification-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                                    <path fill-rule="evenodd"
                                        d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="notification-content">
                                <div class="notification-message">{{ notification.message }}</div>
                                <div class="notification-time">{{ notification.sent_at | dateAgo }}</div>
                            </div>
                            <div class="unread-badge" *ngIf="notification.isUnread"></div>
                        </ng-template>
                    </div>
                    <div *ngIf="filteredNotifications.length === 0 && activeTab == 'RN'" class="mt-4 PacelId">
                        No Recent Notification
                    </div>
                </div>
                <div class="PacelId mt-4">
                    <ul *ngIf="tripHistory&& tripHistory.length > 0">
                        <li *ngFor="let trip of tripHistory">
                            <span class="Parcel_T">Order ID {{ trip.order_no ? trip.order_no : trip.po }} <span
                                    class="min-ago">{{trip.localDelyDate}}</span></span>
                            <div class="AddressTitle">
                             <div class="order-icon"
     [class.pickup]="trip.order_type === 'pickup'"
     [class.delivery]="trip.order_type === 'delivery'"
     [class.warehouse]="trip.order_type === 'warehouse'">

  <!-- ===== DELIVERY ICONS ===== -->
  <ng-container *ngIf="trip.order_type === 'delivery'">

    <!-- Unassigned Delivery -->
    <svg *ngIf="!trip?.current_driver?.id"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         style="width: 48px; height: 48px;">
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="#9ca3af" stroke-width="1" fill="none"/>
      <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100"
            fill="#9ca3af" font-family="Arial, sans-serif">D</text>
    </svg>

    <!-- Assigned Delivery -->
    <svg *ngIf="trip?.current_driver?.id"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         style="width: 48px; height: 48px;">
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="#008A51" stroke-width="1" fill="none"/>
      <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100"
            fill="#008A51" font-family="Arial, sans-serif">D</text>
    </svg>

  </ng-container>


  <!-- ===== PICKUP ICONS ===== -->
  <ng-container *ngIf="trip.order_type === 'pickup'">

    <!-- Unassigned Pickup -->
    <svg *ngIf="!trip?.current_driver?.id"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         style="width: 48px; height: 48px;">
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="#F9A8D4" stroke-width="1" fill="none"/>
      <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100"
            fill="#F9A8D4" font-family="Arial, sans-serif">P</text>
    </svg>

    <!-- Assigned Pickup -->
    <svg *ngIf="trip?.current_driver?.id"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         style="width: 48px; height: 48px;">
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="#DB2777" stroke-width="1" fill="none"/>
      <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100"
            fill="#DB2777" font-family="Arial, sans-serif">P</text>
    </svg>

  </ng-container>


  <!-- ===== WAREHOUSE ICON ===== -->
  <ng-container *ngIf="trip.order_type === 'warehouse'">
    <svg *ngIf="trip?.current_driver?.id"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         style="width: 48px; height: 48px;">
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="#1e40af" stroke-width="1" fill="none"/>
      <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100"
            fill="#1e40af" font-family="Arial, sans-serif">W</text>
    </svg>
  </ng-container>

</div>


                                <p>
                                    <strong>Delivered To: {{trip.customer_name}}</strong>
                                    <span>Addrees: {{trip.customer_addr}}</span>
                                    <span class="InfoHere">Phone Number: {{trip.customer_phone}}</span>
                                    <!-- <button  class="ViewButton">View</button> -->
                                </p>
                            </div>
                        </li>
                    </ul>
                    <div *ngIf=" tripHistory && tripHistory.length === 0 && activeTab == 'RTH'" class="mt-4 PacelId">
                        No Recent Trip History
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>